export default __webpack_public_path__ + "static/media/news77.fba032c4.jpg";